"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ShopContext = _interopRequireDefault(require("../context/ShopContext"));

var _shopReducer = _interopRequireDefault(require("../reducers/shop/shopReducer"));

var _shopActions = require("../reducers/shop/shopActions");

var _useSchema3 = _interopRequireDefault(require("../hooks/useSchema"));

var _useGetAwyesContent5 = _interopRequireDefault(require("../hooks/useGetAwyesContent"));

var _formatters = require("../libs/formatters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BASKET_ID = '~~basket~~';
var WISHLIST_ID = '~~wishlist~~';
var WISHLIST_MAX = 12;
var BASKET_MAX = 20;

var ShopProvider = function ShopProvider(_ref) {
  var children = _ref.children;

  var _useSchema = (0, _useSchema3["default"])(),
      _useSchema2 = _slicedToArray(_useSchema, 1),
      products = _useSchema2[0].products;

  var _useGetAwyesContent = (0, _useGetAwyesContent5["default"])(),
      _useGetAwyesContent2 = _slicedToArray(_useGetAwyesContent, 2),
      _useGetAwyesContent2$ = _useGetAwyesContent2[0],
      wishlistError = _useGetAwyesContent2$.error,
      wishlistLoading = _useGetAwyesContent2$.loading,
      wishlistComplete = _useGetAwyesContent2$.complete,
      wishlistProducts = _useGetAwyesContent2$.items,
      wishlistNotFound = _useGetAwyesContent2$.notFound,
      requestWishlistProducts = _useGetAwyesContent2[1].request;

  var _useGetAwyesContent3 = (0, _useGetAwyesContent5["default"])(),
      _useGetAwyesContent4 = _slicedToArray(_useGetAwyesContent3, 2),
      _useGetAwyesContent4$ = _useGetAwyesContent4[0],
      basketError = _useGetAwyesContent4$.error,
      basketLoading = _useGetAwyesContent4$.loading,
      basketComplete = _useGetAwyesContent4$.complete,
      basketProducts = _useGetAwyesContent4$.items,
      basketNotFound = _useGetAwyesContent4$.notFound,
      requestBasketProducts = _useGetAwyesContent4[1].request;

  var _useReducer = (0, _react.useReducer)(_shopReducer["default"], {
    wishlist: JSON.parse(localStorage.getItem(WISHLIST_ID) || '[]'),
    basket: JSON.parse(localStorage.getItem(BASKET_ID) || '[]')
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      wishlist = _useReducer2$.wishlist,
      basket = _useReducer2$.basket,
      shopDispatch = _useReducer2[1];

  var isAllowedProductType = (0, _react.useCallback)(function (awyesId) {
    var _extractAwyesId;

    var allowedTypes = Object.keys(products);

    var _ref2 = (_extractAwyesId = (0, _formatters.extractAwyesId)(awyesId)) !== null && _extractAwyesId !== void 0 ? _extractAwyesId : {},
        typeName = _ref2.typeName;

    return !!(typeName && allowedTypes.includes(typeName));
  }, [products]);
  (0, _react.useEffect)(function () {
    var onStorageChange = function onStorageChange() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          key = _ref3.key,
          newValue = _ref3.newValue;

      if (key === WISHLIST_ID) {
        shopDispatch({
          type: _shopActions.SET_WISHLIST,
          wishlist: JSON.parse(newValue || '[]')
        });
      } else if (key === BASKET_ID) {
        shopDispatch({
          type: _shopActions.SET_BASKET,
          basket: JSON.parse(newValue || '[]')
        });
      }
    };

    window.addEventListener('storage', onStorageChange);
    return function () {
      window.removeEventListener('storage', onStorageChange);
    };
  }, []);
  var updateWishlist = (0, _react.useCallback)(function (newList) {
    if ((wishlist === null || wishlist === void 0 ? void 0 : wishlist.length) !== newList.length) {
      var trimmed = newList.reverse().slice(0, WISHLIST_MAX);

      try {
        localStorage.setItem(WISHLIST_ID, JSON.stringify(trimmed));
      } catch (e) {
        console.log('Failed to store wishlist', e);
      }

      shopDispatch({
        type: _shopActions.SET_WISHLIST,
        wishlist: trimmed
      });
    }
  }, [wishlist]);
  var wishlistAdd = (0, _react.useCallback)(function (awyesId) {
    if (isAllowedProductType(awyesId)) {
      updateWishlist(wishlist ? _toConsumableArray(new Set([].concat(_toConsumableArray(wishlist), [awyesId]))) : [awyesId]);
    }
  }, [wishlist, updateWishlist, isAllowedProductType]);
  var wishlistRemove = (0, _react.useCallback)(function (awyesIds) {
    var deadIds = Array.isArray(awyesIds) ? awyesIds : [awyesIds];
    updateWishlist(wishlist ? wishlist.filter(function (id) {
      return !deadIds.includes(id);
    }) : []);
  }, [wishlist, updateWishlist]);
  var wishlistToggle = (0, _react.useCallback)(function (awyesId) {
    if (isAllowedProductType(awyesId)) {
      if (wishlist !== null && wishlist !== void 0 && wishlist.includes(awyesId)) {
        wishlistRemove(awyesId);
      } else {
        wishlistAdd(awyesId);
      }
    }
  }, [wishlist, wishlistAdd, wishlistRemove, isAllowedProductType]);
  var updateBasket = (0, _react.useCallback)(function (newList) {
    if ((basket === null || basket === void 0 ? void 0 : basket.length) !== newList.length) {
      var trimmed = newList.reverse().slice(0, BASKET_MAX);

      try {
        localStorage.setItem(BASKET_ID, JSON.stringify(trimmed));
      } catch (e) {
        console.log('Failed to store basket', e);
      }

      shopDispatch({
        type: _shopActions.SET_BASKET,
        basket: trimmed
      });
    }
  }, [basket]);
  var basketAdd = (0, _react.useCallback)(function (awyesId) {
    if (isAllowedProductType(awyesId)) {
      updateBasket(basket ? _toConsumableArray(new Set([].concat(_toConsumableArray(basket), [awyesId]))) : [awyesId]);
      wishlistRemove(awyesId);
    }
  }, [basket, updateBasket, isAllowedProductType, wishlistRemove]);
  var basketRemove = (0, _react.useCallback)(function (awyesIds) {
    var deadIds = Array.isArray(awyesIds) ? awyesIds : [awyesIds];
    updateBasket(basket ? basket.filter(function (id) {
      return !deadIds.includes(id);
    }) : []);
  }, [basket, updateBasket]);
  var basketClear = (0, _react.useCallback)(function () {
    updateBasket([]);
  }, [updateBasket]);
  var basketToggle = (0, _react.useCallback)(function (awyesId) {
    if (isAllowedProductType(awyesId)) {
      if (basket !== null && basket !== void 0 && basket.includes(awyesId)) {
        basketRemove(awyesId);
      } else {
        basketAdd(awyesId);
      }
    }
  }, [basket, basketAdd, basketRemove, isAllowedProductType]);
  return /*#__PURE__*/_react["default"].createElement(_ShopContext["default"], {
    value: {
      wishlist: wishlist,
      wishlistAdd: wishlistAdd,
      wishlistRemove: wishlistRemove,
      wishlistToggle: wishlistToggle,
      wishlistError: wishlistError,
      wishlistLoading: wishlistLoading,
      wishlistComplete: wishlistComplete,
      wishlistProducts: wishlistProducts,
      wishlistNotFound: wishlistNotFound,
      requestWishlistProducts: requestWishlistProducts,
      basket: basket,
      basketAdd: basketAdd,
      basketRemove: basketRemove,
      basketToggle: basketToggle,
      basketClear: basketClear,
      basketError: basketError,
      basketLoading: basketLoading,
      basketComplete: basketComplete,
      basketProducts: basketProducts,
      basketNotFound: basketNotFound,
      requestBasketProducts: requestBasketProducts,
      BASKET_MAX: BASKET_MAX,
      WISHLIST_MAX: WISHLIST_MAX
    }
  }, children);
};

var _default = ShopProvider;
exports["default"] = _default;